<!--
@Author: MIYONGLE
@Desc: 关于我们
@Date: 2021-07-28 13时
-->

<template>
  <div>
    <!-- 顶部 -->
    <mMenusNav><span>{{ titleName }}</span></mMenusNav>

    <!-- bannar -->
    <div class="about-bannar">
      <span>场景化<br>灵活用工服务平台</span>
      <span>用科技赋能数字化就业与协同治理</span>
    </div>

    <!-- tabbar -->
    <div class="tabbar-con">
      <div v-for="(item,index) of tabbarConst" :key="index" class="tabbar-con-jump" @click="jumpPage(item.path)">
        <img :src="$route.path === item.path ? item.selectIcon : item.icon" alt="慧用工"/>
        <span :class="$route.path === item.path ? 'active' : ''">{{item.text}}</span>
      </div>
    </div>

    <!-- 内容 -->
    <router-view></router-view>

    <!-- form弹窗 -->
    <mFrom :source='source'></mFrom>
  </div>
</template>

<script type="text/javascript">
import mMenusNav from "../../components/mMenusNav";
import mFrom from "../../components/mFrom";
import {ABOUT_US_TABBAR} from "../../service/businessConsts"
import {changeJumpPageUrl} from '../../filters/filters';

export default {
  name: "mAbout-user",
  data() {
    return {
      titleName: '关于我们',
      source: '',
      tabbarConst: ABOUT_US_TABBAR
    }
  },

  components: {
    mMenusNav: mMenusNav,
    mFrom: mFrom,
  },

  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=mgywm' : '&pageFrom=mgywm';
  },

  methods: {
    
    // 页面跳转
    jumpPage(url){
      this.$router.push({
        path: changeJumpPageUrl(url)
      })
    },
  }
}
</script>

<style lang="scss" scoped>

  //bannar
  .about-bannar{
    width: 100%;
    height: 1080px;
    background: url('../../../static/mobile/aboutUs/banner_aboutus_1.png') no-repeat top center;
    background-size: 100%;
    background-color: #100f0f;
    color: #FFFFFF;
    span{
      display: block;
    }

    span:nth-child(1){
      font-size: 60px;
      font-weight: 600;
      padding-top: 354px;
    }

    span:nth-child(2){
      font-size: 24px;
      font-weight: 600;
      margin-top: 29px;
    }
  }

  // tabbar 
  .tabbar-con{
    padding: 29px 80px;
    box-sizing: border-box;
    height: 140px;
    background:rgba(25, 133, 255, 0.05);
    display: flex;
    justify-content: space-between;
    .tabbar-con-jump{
      position: relative;
      display: block;
      img{
        display: block;
        width: 44px;
        height: 44px;
        text-align: center;
        margin: 0 auto;
      }

      span{
        color: #171E2E;
        margin-top: 8px;
        display: block;
        font-weight: 600;
      }
      
      .active{
        color: #1985FF;
      }
    }

    .tabbar-con-jump:not(:last-child)::after{
      content: ' ';
      width: 1px;
      height: 60px;
      background: #CFCFCF;
      display: inline-block;
      position: absolute;
      top: 10px;
      right: -80px;
    }

    
  }
</style>


// WEBPACK FOOTER //
// src/views/mobile/mAboutUser.vue